import React from "react";

export type RssReaderCardStatProps = {
  label: string;
  value: string;
};

const RssReaderCardStat: React.FC<RssReaderCardStatProps> = ({
  label,
  value,
}) => {
  return (
    <div>
      <div className="text-subhead-2xs text-body-primary sm:text-subhead-s font-bold">
        {value}
      </div>
      <div className="text-body-s text-body-secondary">{label}</div>
    </div>
  );
};

export default RssReaderCardStat;
